import { config } from '@abyss/web/tools/config';
import { Flex } from '@abyss/web/ui/Flex';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ProviderSummaryTypes } from '../../../../../common/Constants';
import {
  PreferredProviderContainer,
  PrintViewProviderDetailsXSText,
} from './PrintView.style';

const Preferred_Lab = `${config(
  'CDN_BASE_URL'
)}/cdn/assets/images/preferred_lab_network.svg`;
const Freestanding_Facility = `${config(
  'CDN_BASE_URL'
)}/cdn/assets/images/freestanding_facility.svg`;
const Designated_Diagnostic = `${config(
  'CDN_BASE_URL'
)}/cdn/assets/images/check-circle.svg`;

type Props = {
  providerType: ProviderSummaryTypes | undefined;
  showDDP: boolean;
  showFSF: boolean;
  showPreferredContent: boolean | undefined;
  showPLN: boolean;
  showOxford: boolean;
};

export const PreferredProviderLabels = ({
  providerType,
  showDDP,
  showFSF,
  showPLN,
  showOxford,
  showPreferredContent,
}: Props) => {
  const { t } = useTranslation();

  if (
    !showPreferredContent ||
    providerType !== ProviderSummaryTypes.ORGANIZATION
  ) {
    return null;
  }

  return (
    <Flex
      css={{
        'abyss-flex-root': {
          gap: '2px',
          padding: 0,
          alignItems: 'flex-end',
          display: 'flex',
          flex: '1',
          flexWrap: 'nowrap',
        },
      }}
      direction="column"
    >
      {showDDP ? (
        <PreferredProviderContainer>
          <img
            src={Designated_Diagnostic}
            style={{
              width: '12px',
              height: '12px',
              marginRight: '5px',
              filter: 'grayscale(100%)',
              alignSelf: 'center',
            }}
          />
          <PrintViewProviderDetailsXSText color="#333333">
            {t('SHARE_PDF.Designated Diagnostic')}
          </PrintViewProviderDetailsXSText>
        </PreferredProviderContainer>
      ) : null}
      {showFSF ? (
        <PreferredProviderContainer>
          <img
            src={Freestanding_Facility}
            style={{
              width: '12px',
              height: '12px',
              marginRight: '5px',
              filter: 'grayscale(100%)',
              alignSelf: 'center',
            }}
          />
          <PrintViewProviderDetailsXSText color="#333333">
            {t('SHARE_PDF.Freestanding Facility')}
          </PrintViewProviderDetailsXSText>
        </PreferredProviderContainer>
      ) : null}
      {showOxford ? (
        <PreferredProviderContainer>
          <img
            src={Preferred_Lab}
            style={{
              width: '12px',
              height: '12px',
              marginRight: '5px',
              filter: 'grayscale(100%)',
              alignSelf: 'center',
            }}
          />
          <PrintViewProviderDetailsXSText color="#333333">
            {t('SHARE_PDF.Oxford Preferred Lab')}
          </PrintViewProviderDetailsXSText>
        </PreferredProviderContainer>
      ) : showPLN ? (
        <PreferredProviderContainer>
          <img
            src={Preferred_Lab}
            style={{
              width: '12px',
              height: '12px',
              marginRight: '5px',
              filter: 'grayscale(100%)',
              alignSelf: 'center',
            }}
          />
          <PrintViewProviderDetailsXSText color="#333333">
            {t('SHARE_PDF.Preferred Lab Network')}
          </PrintViewProviderDetailsXSText>
        </PreferredProviderContainer>
      ) : null}
    </Flex>
  );
};
